import assert from 'assert';

export function prependListener<T>(target: {listeners: Set<T>}, listener: T) {
  assert(target, 'Target must be specified');
  assert(target.listeners, 'Target must have listeners property');
  assert(target.listeners instanceof Set, 'target.listeners must be a Set');

  const newListeners = [listener, ...Array.from(target.listeners)];
  target.listeners = new Set(newListeners);
  return () => {
    target.listeners.delete(listener);
  };
}
